import React from 'react'
import { Switch, Route } from 'react-router-dom'
import TagManager from "react-gtm-module";
import Home from './Home'
import About from './About'
import Partners from './Partners'
import Products from './Products'
import ThePlatformSolution from './product/ThePlatformSolution'
import PowerfulProducts from './product/PowerfulProducts'
import OmniChannel from './product/OmniChannel'
import MarketingOperational from './product/MarketingOperational'
import Careers from './Careers'
import Contact from './Contact'
import News from './News'
import Affiliate from "./Affiliate";
import TermsConditions from './TermsConditions'
import Cookies from './Cookies'
import PrivacyPolicy from './PrivacyPolicy'
import Post from './Post'
import Notfound from "./Notfound";

const tagManagerArgs = {
  gtmId: "GTM-KNJGVQN"
};

TagManager.initialize(tagManagerArgs);

const Main = () => (
  <Switch>
    <Route exact path="/" component={Home} />
    <Route path="/about" component={About} />
    <Route path="/partners" component={Partners} />
    <Route path="/products" component={Products} />
    <Route path="/product/the-platform-solution" component={ThePlatformSolution} />
    <Route path="/product/powerful-products-and-partners" component={PowerfulProducts} />
    <Route path="/product/omni-channel" component={OmniChannel} />
    <Route path="/product/marketing-operational-services" component={MarketingOperational} />
    <Route path="/careers" component={Careers} />
    <Route path="/contact" component={Contact} />
    <Route path="/news" component={News} />
    <Route path="/affiliate" component={Affiliate} />
    <Route path="/termsconditions" component={TermsConditions} />
    <Route path="/cookies" component={Cookies} />
    <Route path="/privacypolicy" component={PrivacyPolicy} />
    <Route path="/post/:post_id" component={Post} />
    <Route component={Notfound} />
  </Switch>
);

export default Main
